module.exports = __webpack_public_path__ + "vendor/blockly/media/delete.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=[path][name].[ext]!./vendor/blockly/media/delete.wav
 ** module id = 605
 ** module chunks = 0
 **/